var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { environment } from '../environment';
var SharedService = SharedService_1 = (function () {
    function SharedService() {
        //console.log("SharedService created");
        SharedService_1._instance = this;
    }
    SharedService.setEnv = function (env) {
        console.debug("loading env ...");
        Object.keys(env).map(function (k) {
            environment[k] = env[k];
            console.debug(k + ": " + env[k]);
        });
    };
    SharedService.b64EncodeUnicode = function (msg) {
        return btoa(encodeURIComponent(msg).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt(p1, 16));
        }));
    };
    SharedService.unescape = function (str) {
        return str.replace(/%[0-9A-Fa-f]{2}/g, function (match) {
            return String.fromCharCode(parseInt(match.substring(1), 16));
        });
    };
    Object.defineProperty(SharedService, "instance", {
        get: function () {
            return this._instance || new SharedService_1();
        },
        enumerable: true,
        configurable: true
    });
    SharedService.prototype.getProp = function (key) {
        return environment[key];
    };
    SharedService.getProp = function (key) {
        return SharedService_1.instance.getProp(key);
    };
    SharedService.prototype.isLocalData = function () {
        return SharedService_1.instance.getProp("local_data");
    };
    SharedService.prototype.getTimeOut = function () {
        //console.log("timeout " + SharedService.instance.getProp("timeout"));
        return SharedService_1.instance.getProp("timeout") * 60;
    };
    SharedService.prototype.url = function () {
        if (this.isLocalData()) {
            if (SharedService_1.isDesarrollo()) {
                return document.location.origin + "/app/data/";
            }
            else {
                return document.location.origin + "/iol-ui/app/data/";
            }
        }
        else {
            return this.urlSer();
        }
    };
    SharedService.prototype.urlSer = function () {
        // if (this.isDesarrollo()) {
        return SharedService_1.instance.getProp("services_url");
        // } else {
        // return "http://" + document.location.hostname
        // + (document.location.port ? ":" + document.location.port : "")
        // + "/iurix-services/api/";
        // }
    };
    SharedService.prototype.urlPublic = function () {
        var configUrl = SharedService_1.instance.getProp("remoteConfig").toString();
        //console.log("location: " + location);
        if (configUrl.toLowerCase().indexOf("self") > -1) {
            configUrl = location.protocol + '//' + location.hostname;
            if (location.port && location.port == "3000") {
                configUrl = configUrl + ":8280/iol-ui";
            }
            else if (location.port) {
                configUrl = configUrl + ":" + location.port;
            }
            //console.log("configUrl = " + configUrl); 
            //configUrl = configUrl + location.pathname.substring(0, location.pathname.indexOf('/', 1)) 
            //+ "/api/";
            configUrl = configUrl + "/iurix-services/api/";
            //console.log("configUrl = " + configUrl); 
        }
        else {
            configUrl = configUrl.replace("/api/env/", "/api/");
        }
        return configUrl;
    };
    SharedService.isKCDevMode = function () {
        return SharedService_1.instance.getProp("kcdevmode");
    };
    SharedService.isDesarrollo = function () {
        return SharedService_1.instance.getProp("desarrollo");
    };
    SharedService.kcRealm = function () {
        return SharedService_1.instance.getProp("kcRealm");
    };
    SharedService.prototype.dataSiteKey = function () {
        return SharedService_1.instance.getProp("data_sitekey");
    };
    SharedService.prototype.getCantAperturaExp = function () {
        return SharedService_1.instance.getProp("CANT_APERTURAS_EXP");
    };
    SharedService.prototype.getMinutosExp = function () {
        return SharedService_1.instance.getProp("CANT_MINUTOS_EXP");
    };
    SharedService.prototype.getCantCaptchaExp = function () {
        return SharedService_1.instance.getProp("CANT_CAPTCHA_EXP");
    };
    SharedService.prototype.getCantAperturaAct = function () {
        return SharedService_1.instance.getProp("CANT_APERTURAS_ACT");
    };
    SharedService.prototype.getMinutosAct = function () {
        return SharedService_1.instance.getProp("CANT_MINUTOS_ACT");
    };
    SharedService.prototype.getCantCaptchaAct = function () {
        return SharedService_1.instance.getProp("CANT_CAPTCHA_ACT");
    };
    SharedService.prototype.getCheckDouble = function () {
        return SharedService_1.instance.getProp("checkDoubleInic") === true;
    };
    SharedService.prototype.getCheckDoubleM = function () {
        return SharedService_1.instance.getProp("checkDoubleInicM") === true;
    };
    SharedService.prototype.getUseReCaptcha = function () {
        return SharedService_1.instance.getProp("useRecaptcha") === true;
    };
    SharedService.prototype.getMsgExp = function () {
        return SharedService_1.instance.getProp("CATCHA_MAIL_MENS_EXP");
    };
    SharedService.prototype.getMsgAct = function () {
        return SharedService_1.instance.getProp("CATCHA_MAIL_MENS_ACT");
    };
    SharedService.prototype.getTextoTasa = function () {
        return SharedService_1.instance.getProp("TEXTO_TASA");
    };
    SharedService.prototype.getLinkTasa = function () {
        return SharedService_1.instance.getProp("LINK_TASA");
    };
    SharedService.prototype.getAsuntoCaptcha = function () {
        return SharedService_1.instance.getProp("CATCHA_MAIL_ASUNTO");
    };
    return SharedService;
}());
SharedService._instance = null;
SharedService = SharedService_1 = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], SharedService);
export { SharedService };
export var UI_MODE = {
    "LIST": 0, "NEW": 1, "VIEW": 2, "EDIT": 3, "SEARCH": 4
};
var SharedService_1;
//# sourceMappingURL=shared.service.js.map